import React from 'react';
import IconList, { CircleProps, IRectProps, PathProps, PolygonProps, SVGProps } from './IconList';
import { IconTypes } from './IconTypes';

interface IconProps {
  icon: IconTypes;
  fill?: any;
  width?: number;
  height?: number;
  onClick?: () => void;
  style?: any;
  label?: string;
  className?: string;
  dataCy?: string;
  tooltipId?: string;
}

const Icon: React.FC<IconProps> = ({ icon, fill, width = 16.5, height = 16.5, onClick, style, className, label, dataCy = 'icon', tooltipId }) => {
  const haveSVG = Object.prototype.hasOwnProperty.call(IconList, icon);
  const svg: SVGProps | null = haveSVG ? IconList[icon] : null;

  if (!svg) return null;

  const attributes: Record<string, string | boolean | undefined> = {
    ...(label ? { 'aria-label': label } : { 'aria-hidden': true }),
    ...(tooltipId ? { 'data-tooltip-id': tooltipId } : {}),
  };

  return (
    <svg width={width} height={height} viewBox={svg.viewbox} onClick={onClick} style={style} className={className} data-cy={dataCy} {...attributes}>
      <g fill={fill && fill}>
        {svg.rects ? svg.rects.map(({ x, y, width, height, fill, rx, stroke }: IRectProps, i) => <rect key={i} x={x} y={y} width={width} height={height} fill={fill} rx={rx} stroke={stroke} />) : null}
        {svg.circles ? svg.circles.map(({ cx, cy, r, fill }: CircleProps) => <circle key={`${cx}-${cy}-${r}`} cx={cx} cy={cy} r={r} fill={fill} />) : null}
        {svg.polygons ? svg.polygons.map(({ points, fill }: PolygonProps, i) => <polygon key={i} points={points} fill={fill} />) : null}
        {svg.paths ? svg.paths.map(({ path, fill, fillRule = 'evenodd' }: PathProps) => <path fillRule={fillRule} key={path} d={path} fill={fill} />) : null}
      </g>
    </svg>
  );
};

export default Icon;
